import React from 'react';
const elementTypes = {
  text: 'text',
  headline: 'headline',
  list: 'list',
  react: 'react'
};

/**
 * Returns an HTML element based on type and value.
 * @param type
 * @param value
 * @returns {(function(*): (*|null))|*}
 */
const getElement = ({
  type,
  value,
  index
}) => {
  switch (type) {
    case elementTypes.headline:
      return /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, value));
    case elementTypes.list:
      return /*#__PURE__*/React.createElement("ul", {
        key: index
      }, value.map((v, index) => Array.isArray(v) ? getElement({
        type,
        value: v,
        index
      }) : /*#__PURE__*/React.createElement("li", {
        key: index
      }, v)));
    case elementTypes.text:
      return /*#__PURE__*/React.createElement("p", null, value);
    case elementTypes.react:
    default:
      return value;
  }
};
export default getElement;